module.exports = __webpack_public_path__ + "img/a.1e5b5505.jpg";